import { inGamecenter } from '@platform/shared';
import Inner from './components/Inner';

export default {
  name: 'Sidebar',
  components: {
    Inner,
  },
  props: {
    contextSlug: {
      type: String,
    },
    documentSlug: {
      type: String,
    },
    list: {
      type: Array,
      default: () => [],
    },
    projectTitle: {
      type: String,
    },
  },
  data: () => ({
    isMenuOpened: false,
  }),
  computed: {
    isGCPage() {
      return !!inGamecenter;
    },
    isNoMenu() {
      return this.$route.query.nomenu === '1';
    },
    isMGVCPage() {
      return document.domain.endsWith('mgvc.com');
    },
  },
  methods: {
    openMobileMenu() {
      this.isMenuOpened = !this.isMenuOpened;
    },
  },
};
